import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaBook,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CreativeStorytellingVideoProductionInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Creative Storytelling Video Production in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Captivate Your Audience</Subheading>}
        heading={
          <Heading>
            Creative <span tw="text-primary-500">Storytelling Video</span>{" "}
            Production in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in creative storytelling video
            production in **DIFC**, crafting cinematic narratives that resonate
            emotionally and elevate your brand. Our videos tell compelling
            stories that engage and inspire audiences.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1601506521937-0b4218f2e801?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Film production setup
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Creative lighting effects
          "https://images.unsplash.com/photo-1580983218765-f663bec07b37?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Tell Your Story"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Cinematic Storytelling in DIFC"
        description="We create narrative-driven videos that leave a lasting impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Narratives",
            description: "Visually stunning stories that captivate.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Expert Storytellers",
            description: "Skilled team with a passion for narrative.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Emotional Engagement",
            description: "Videos that connect with your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Production",
            description: "Timely delivery with creative excellence.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for web, social, and presentations.",
          },
          {
            icon: <FaBook color="#ff5464" size={40} />,
            title: "Brand Storytelling",
            description: "Tailored narratives for DIFC businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Storytelling Video Process"
        description={
          <Description>
            We craft compelling storytelling videos with a meticulous process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your brand’s story and goals.</li>
              <li>Scripting: Develop emotionally resonant narratives.</li>
              <li>Storyboarding: Plan visually captivating sequences.</li>
              <li>Filming: Capture with cinematic equipment.</li>
              <li>
                Editing: Polish visuals and audio for storytelling impact.
              </li>
              <li>Delivery: Provide ready-to-share storytelling videos.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Studio production setup
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Artistic video composition
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Storytelling Video Wins in DIFC"
        description="Our narrative videos have inspired DIFC audiences."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Stories",
            description: "Drove emotional connection with brands.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Engagement",
            description: "Boosted visibility for DIFC businesses.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from storytelling projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Compelling Stories?</Subheading>}
        heading="Storytelling Video Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for creative storytelling video
            production in DIFC. Craft cinematic, narrative-driven videos that
            captivate and inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1546412414-e1885259563a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
